<template >
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form @submit.stop.prevent="handleOk">
      <b-row class="pb-1 pr-0">
        <b-col md="2" class="px-1 mb-1">
          <multiselect
            v-model="regiaoSelected"
            :options="this.$parent.optionsRegiao"
            track-by="regiao_id"
            label="label"
            :limit="10"
            :multiple="true"
            :clear-on-select="false"
            :hide-selected="true"
            placeholder="Região"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
        </b-col>
        <b-col md="4" class="px-1 mb-1">
          <multiselect
            v-model="redespachoSelected"
            :options-limit="300"
            :limit="10"
            :multiple="true"
            :limit-text="limitText"
            :options="optionsRedespacho"
            track-by="value"
            label="label"
            id="redespacho"
            :hide-selected="true"
            placeholder="Redespacho ( Digite 3 caracteres para pesquisar )"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :loading="isLoadingRedespacho"
            @search-change="listaRedespacho"
          ></multiselect>
        </b-col>
        <b-col class="px-1 mb-1" md="3">
          <b-input
            id="cdBarra"
            maxlength="31"
            autofocus
            type="text"
            v-on:keyup.enter="onScan()"
            @keydown="handleKeyDown"
            @contextmenu="handleWritingBarcodePermission($event)"
            @dragover="handleWritingBarcodePermission($event)"
            @paste="handleWritingBarcodePermission($event)"
            @drop="handleWritingBarcodePermission($event)"
            v-model="cd_barra"
            ref="cdBarra"
          ></b-input>
          <span>Qtde. caracteres código de barra: {{ qtdCaracteres() }}</span>
        </b-col>
        <b-col class="px-1 mb-1">
          <b-btn :disabled="loading" @click="onScan()" variant="secondary"
            >Escanear código</b-btn
          >
        </b-col>
      </b-row>
    </form>
    <b-row class="pb-1 pr-0">
      <b-col md="2" class="px-1 mb-1">
        <span>Observação</span>
        <b-input
          type="text"
          v-model="observacao"
          :disabled="this.notas_fiscais.length == 0 || this.form.carga_id == ''"
          :maxlength="10"
          v-on:change="onUpdateObs()"
        ></b-input>
      </b-col>
      <b-col md="1" class="px-1 mb-1">
        <span>N° Carga</span>
        <b-input disabled type="text" v-model="num_carga"></b-input>
      </b-col>
      <b-col md="1" class="px-1 mb-1">
        <span>Qtde. NFs</span>
        <b-input disabled type="text" v-model="qtde_nfs"></b-input>
      </b-col>
      <b-col md="1" class="px-1 mb-1">
        <span>Peso Bruto</span>
        <currency-input
          class="form-control"
          v-model="peso_bruto_total"
          placeholder="Peso total bruto"
          disabled
          :auto-decimal-mode="true"
          :currency="{ prefix: ' ' }"
          :distraction-free="getCurrency"
        />
      </b-col>
      <b-col md="4" style="display: flex; align-items: center">
        <span>Qtde. volumes bipados / Total de volumes : </span>
        <h4 class="ml-1">
          {{ this.qtd_volumes_bipados_total }}/{{ this.qtd_volumes_total }}
        </h4>
      </b-col>
    </b-row>
    <div class="horizontal-scroll">
      <div class="loadingDataPosition">
        <div class="loadingData" v-if="loading"></div>
        <vuetable
          ref="vuetable"
          :api-mode="false"
          :data="notas_fiscais"
          :fields="fields"
          :css="css"
          :append-params="moreParams"
          :row-class="onRowClass"
          track-by="docfis_id"
          pagination-path=""
          @vuetable:load-error="onError"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loaded="onLoaded"
          detail-row-component="montagemcargaform-detalhes"
          @vuetable:cell-clicked="onDetail"
        >
          <template slot="actions" slot-scope="props">
            <div class="custom-actions">
              <a
                @click="onDetail(props.rowData, null, null)"
                v-b-tooltip
                title="Ver detalhes"
                ><i class="fa fa-plus"></i
              ></a>
              <a
                :disabled="loading"
                @click="onRemoveNf(props.rowData, notas_fiscais)"
                v-b-tooltip
                title="Remover nota"
                v-if="getPermission('montagemcarga.removernf')"
                ><i class="fa fa-times"></i
              ></a>
            </div>
          </template>
          <template slot="status" slot-scope="props">
            <span
              class="badge badge-warning"
              v-if="props.rowData.status.valor == 3"
              >{{ props.rowData.status.descr }}</span
            >
            <span
              class="badge badge-success"
              v-if="props.rowData.status.valor == 2"
              >{{ props.rowData.status.descr }}</span
            >
            <span
              class="badge badge-warning"
              v-if="props.rowData.status.valor == 1"
              >{{ props.rowData.status.descr }}</span
            >
          </template>
          <template slot="quantidade" slot-scope="props">
            <span
              >{{ props.rowData.qtde_bipada }} /
              {{ props.rowData.qtde_total }}</span
            >
          </template>
          <template slot="regiao_despesa" slot-scope="props">
            <span v-if="props.rowData.regiao_despesa != null">{{
              props.rowData.regiao_despesa.cd +
              " - " +
              props.rowData.regiao_despesa.descr
            }}</span>
            <span
              v-if="
                props.rowData.regiao_despesa == null &&
                props.rowData.regiao_despesa_rps != null
              "
              >{{ props.rowData.regiao_despesa_rps.texto }}</span
            >
          </template>
        </vuetable>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right" style="display: flex">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="onValidate($event, false)" variant="secondary">
          Validar
        </b-btn>
        <b-btn @click="handleFechar()" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event, false)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Finalizar
        </b-btn>
        <b-btn
          @click="handleOk($event, true)"
          variant="secondary"
          v-if="getPermission('montagemcarga.finalizarcargaespecial')"
        >
          Finalizar carga especial
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MontagemCargaFormDetalhes from "./MontagemCargaFormDetalhes.vue";
import WritingBarcodePermission from '../mixins/WritingBarcodePermission';

Vue.component("montagemcargaform-detalhes", MontagemCargaFormDetalhes);

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    MontagemCargaFormDetalhes,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  mixins: [WritingBarcodePermission],
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      tp_fechar: false,
      permission: true,
      paste: false,
      modal_botao: "",
      modal_acao: "",
      song: new Audio(),
      sucesso: require("../../public/audio/sucesso.mp3"),
      erro: require("../../public/audio/erro.mp3"),
      loading: false,
      permite_digitar: false,
      isDisabled: true,
      isDisabledObs: true,
      isDisabledCdBarra: false,
      loadingData: true,
      showModal: false,
      cdBarraRo: true,
      isFullscreen: false,
      inputKey: 0,
      observacao: "",
      errors_array: [],
      notas_fiscais: [],
      ultimaTeclaPressionada: 0,
      qtd_volumes_total: 0,
      qtd_volumes_bipados_total: 0,
      regiaoSelected: [],
      redespachoSelected: [],
      isLoadingRedespacho: false,
      optionsRedespacho: [],
      cd_barra: "",
      qtde_nfs: 0,
      num_carga: "",
      peso_bruto_total: 0,
      doc_fiscal_avariada: false,
      doc_fiscal_recompra: false,
      nota: {
        cnpj: "",
        num_fiscal: "",
        serie: "",
        num_volume: "",
      },
      docfis: [],
      form: new Form({
        docfis: [],
        partipcar_id: "",
        redespacho: [],
        partpemb_id: "",
        partiprod_id: "",
        carga_id: "",
        cd_barra: "",
        carbipdoc_id: "",
        observacao: "",
        is_carga_especial: "",
        regiao: [],
        nota: {},
      }),
      helpForm: new Form({ search: "", docfiscais: [], carga_id: "" }),
      fields: [
        {
          name: "num_fiscal",
          title: "N° Fiscal",
        },
        {
          name: "doc_num_controle",
          title: "Doc",
        },
        {
          name: "__slot:quantidade",
          title: "Qtde.",
        },
        {
          name: "cnpj",
          title: "CNPJ Emi.",
        },
        {
          name: "emi_nome",
          title: "Razão Social Emi.",
        },
        {
          name: "red_nome",
          title: "Redespacho",
        },
        {
          name: "__slot:regiao_despesa",
          title: "Região",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  created() {
    this.setPermissionToCheck('montagemcarga.digitaretiqueta');
  },
  watch: {
    regiaoSelected(obj) {
      this.form.regiao = obj;
    },
    redespachoSelected(obj) {
      this.form.redespacho = obj;
    },
    'cd_barra'(newValue, oldValue) {
      this.handleWritingBarcodePermission(newValue, oldValue)
    }
  },
  methods: {
    handleOk(e, isCargaEspecial) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore(isCargaEspecial);
      } else {
        this.onUpdate(this.form.docfisttra_id);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onCreate(data, tipo, carga_id) {
      this.permite_digitar = this.checkPermissionBip();
      this.errors_array = "";
      this.errors_array = [];
      this.docfis = [];
      this.regiaoSelected = [];
      this.redespachoSelected = [];
      this.cd_barra = "";
      this.observacao = "";
      this.peso_bruto_total = 0;
      this.qtde_nfs = 0;
      this.num_carga = "";
      this.modal_titulo = "Montar Carga";
      this.modal_botao = "Montar Carga";
      this.modal_acao = "i";
      this.form.reset();
      this.notas_fiscais = [];
      this.qtd_volumes_total = 0;
      this.qtd_volumes_bipados_total = 0;
      if (tipo == 2) {
        this.loading = true;
        this.isDisabled = true;
        this.tp_fechar = false;
        if (data !== null) {
          this.form.carga_id = data.cargaBipDoc.cargaId;
        } else {
          this.form.carga_id = carga_id;
        }

        this.form
          .post("/api/montagemcarga/buscacarga")
          .then((response) => {
            new ReturnApi(response, this);
            this.modal_titulo =
              "Montar Carga" + " " + response.data[0].num_carga;
            this.num_carga = response.data[0].num_carga;
            this.isDisabled = false;
            response.data.forEach((item, i) => {
              this.notas_fiscais.push({
                docfis_id: item.docfis_id,
                volumes: item.volumes,
                carga_id: item.carga_id,
                num_carga: item.num_carga,
                num_fiscal: item.num_fiscal,
                qtde_total: item.qtde_total,
                regiao_despesa: item.regiao_despesa,
                regiao_despesa_rps: item.regiao_despesa_rps,
                qtde_bipada: item.qtde_bipada,
                cnpj: item.cnpj,
                emi_nome: item.emi_nome,
                red_nome: item.red_nome,
                doc_id: item.doc_id,
                doc_num_fiscal: item.doc_num_fiscal,
                doc_num_controle: item.doc_num_controle,
                observacao: item.observacao,
                status: item.status,
                doc_fiscal_recompra: item.doc_fiscal_recompra,
                doc_fiscal_avariada: item.doc_fiscal_avariada,
                nota_normal: !item.doc_fiscal_recompra && !item.doc_fiscal_avariada
              });
              if (item.status.valor == 1) {
                this.isDisabled = true;
              }
              if (!item.doc_fiscal_recompra) {
                this.qtd_volumes_total += item.qtde_total;
              }
              this.qtd_volumes_bipados_total += item.qtde_bipada;

              if (!item.doc_fiscal_recompra) {
                this.peso_bruto_total =
                    this.peso_bruto_total + item.peso_bruto_nf;
              }
              this.observacao = item.observacao;
              this.isDisabledObs = false;
            });
            this.form.notas_fiscais = this.notas_fiscais;
            this.qtde_nfs = this.notas_fiscais.length;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.isDisabled = true;
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          })
            .finally(() => {
              this.checaDisabledBotao();
            });
      } else {
        this.tp_fechar = true;
      }

      this.$refs.modal_form.show();
    },
    tocaMusica(musica) {
      this.song.pause();
      this.song.currentTime = 0;
      this.song.src = musica;
      this.song.play();
    },
    onCreateNew(data, tipo, carga_id) {
      this.permite_digitar = this.checkPermissionBip();
      this.errors_array = "";
      this.errors_array = [];
      this.docfis = [];
      this.cd_barra = "";
      this.observacao = "";
      this.peso_bruto_total = 0;
      this.qtde_nfs = 0;
      this.qtd_volumes_total = 0;
      this.qtd_volumes_bipados_total = 0;
      this.modal_titulo = "Montar Carga";
      this.modal_botao = "Montar Carga";
      this.modal_acao = "i";
      const resdespacho = this.form.redespacho ? this.form.redespacho : [];
      const regiao = this.form.regiao ? this.form.regiao : [];
      this.form.reset();
      this.form.redespacho = resdespacho;
      this.form.regiao = regiao;
      this.notas_fiscais = [];
      this.checaDisabledBotao();
      if (tipo == 2) {
        this.loading = true;
        this.tp_fechar = false;
        if (data !== null) {
          this.form.carga_id = data.carga_bip_doc.carga_id;
        } else {
          this.form.carga_id = carga_id;
        }

        this.form
          .post("/api/montagemcarga/buscacarga")
          .then((response) => {
            new ReturnApi(response, this);
            this.modal_titulo =
              "Montar Carga" + " " + response.data[0].num_carga;
            this.num_carga = response.data[0].num_carga;
            response.data.forEach((item, i) => {
              this.notas_fiscais.push({
                docfis_id: item.docfis_id,
                volumes: item.volumes,
                carga_id: item.carga_id,
                num_carga: item.num_carga,
                num_fiscal: item.num_fiscal,
                qtde_total: item.qtde_total,
                qtde_bipada: item.qtde_bipada,
                regiao_despesa: item.regiao_despesa,
                regiao_despesa_rps: item.regiao_despesa_rps,
                cnpj: item.cnpj,
                emi_nome: item.emi_nome,
                red_nome: item.red_nome,
                doc_id: item.doc_id,
                doc_num_fiscal: item.doc_num_fiscal,
                doc_num_controle: item.doc_num_controle,
                observacao: item.observacao,
                status: item.status,
                nota_normal: !response.data.doc_fiscal_recompra && !response.data.doc_fiscal_avariada
              });
              this.qtd_volumes_total += item.qtde_total;
              this.qtd_volumes_bipados_total += item.qtde_bipada;

              this.peso_bruto_total =
                this.peso_bruto_total + item.peso_bruto_nf;
              this.observacao = item.observacao;
              this.isDisabledObs = false;
            });

            this.form.notas_fiscais = this.notas_fiscais;
            this.qtde_nfs = this.notas_fiscais.length;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          })
            .finally(() => {
              this.checaDisabledBotao();
            });
      } else {
        this.tp_fechar = true;
      }

      this.$refs.modal_form.show();
    },
    onScan() {
      this.errors_array = [];
      this.loading = true;
      this.isDisabled = true;
      this.isDisabledObs = true;
      this.form.nota = this.nota;
      this.form.cd_barra = this.cd_barra;
      this.cd_barra = "";
      this.form
        .post("/api/montagemcarga/bip")
        .then((response) => {
          new ReturnApi(response, this);
          this.modal_titulo = "Montar Carga" + " " + response.data.num_carga;
          this.num_carga = response.data.num_carga;

          if(response.data.recompra_avaria_alerta) {
            this.$Simplert.open({
              title: "Atenção",
              message: response.data.recompra_avaria_alerta,
              type: "warning",
              useCloseBtn: true,
              customCloseBtnText: "Fechar",
              onClose: () => {
                this.confirmBeepToShipment(response);
              }
            });
          } else {
            this.confirmBeepToShipment(response);
          }

          this.form.carga_id = response.data.carga_id;
          this.cd_barra = "";
          this.tocaMusica(this.sucesso);
        })
        .catch((errors) => {
          // this.permite_digitar = true;
          if (errors.tp_message == "success") {
            new ReturnApi(errors, this, true, null, null, false);
            this.tocaMusica(this.sucesso);
          } else {
            new ReturnApi(errors, this, true, null, null, false);
            this.tocaMusica(this.erro);

            this.errors_array = "";
            this.errors_array = [];
            this.isDisabled = true;

            if (errors.type == 1) {
              this.$nextTick(() => {
                if (this.$refs.cdBarra) {
                  this.$refs.cdBarra.focus();
                }
              });
            } else {
              this.$refs.cdBarra.blur();
            }

            this.cd_barra = "";
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          }
        })
          .finally(() => {
            this.checaDisabledBotao();
          });
    },
    confirmBeepToShipment(response) {
      if (response.data.tipo == 2) {
        //Busca o index que vai ser alterado
        this.notas_fiscais.forEach((item, i) => {
          if (item.docfis_id == response.data.docfis_id) {
            this.index = i;
          }
        });
        //Caso não tenha o index, faz o push para o array
        if (this.index == undefined) {
          this.notas_fiscais.push({
            docfis_id: response.data.docfis_id,
            volumes: response.data.volumes,
            carga_id: response.data.carga_id,
            num_fiscal: response.data.num_fiscal,
            regiao_despesa: response.data.regiao_despesa,
            regiao_despesa_rps: response.data.regiao_despesa_rps,
            doc_id: response.data.doc_id,
            doc_num_fiscal: response.data.doc_num_fiscal,
            doc_num_controle: response.data.doc_num_controle,
            qtde_total: response.data.qtde_total,
            qtde_bipada: response.data.qtde_bipada,
            cnpj: response.data.cnpj,
            emi_nome: response.data.emi_nome,
            red_nome: response.data.red_nome,
            status: response.data.status,
            doc_fiscal_recompra: response.data.doc_fiscal_recompra,
            doc_fiscal_avariada: response.data.doc_fiscal_avariada,
            nota_normal: !response.data.doc_fiscal_recompra && !response.data.doc_fiscal_avariada
          });

          if (!response.data.doc_fiscal_recompra) {
            // this.qtd_volumes_total += item.qtde_total;
            this.peso_bruto_total =
                this.peso_bruto_total + response.data.peso_bruto_nf;
          }

          this.qtde_nfs = this.notas_fiscais.length;
          this.$snotify.success(
              "Nota fiscal N : " + response.data.num_fiscal + " bipada",
              "Sucesso"
          );
        } else {
          //Faz o update da nota fiscal
          this.$set(this.notas_fiscais, this.index, response.data);
          this.qtd_volumes_bipados_total++;
          this.$snotify.success("Volume bipado", "Sucesso");
        }
      } else {
        this.notas_fiscais.unshift({
          docfis_id: response.data.docfis_id,
          volumes: response.data.volumes,
          carga_id: response.data.carga_id,
          num_carga: response.data.num_carga,
          num_fiscal: response.data.num_fiscal,
          regiao_despesa: response.data.regiao_despesa,
          regiao_despesa_rps: response.data.regiao_despesa_rps,
          doc_id: response.data.doc_id,
          doc_num_fiscal: response.data.doc_num_fiscal,
          doc_num_controle: response.data.doc_num_controle,
          qtde_total: response.data.qtde_total,
          qtde_bipada: response.data.qtde_bipada,
          cnpj: response.data.cnpj,
          emi_nome: response.data.emi_nome,
          red_nome: response.data.red_nome,
          status: response.data.status,
          doc_fiscal_recompra: response.data.doc_fiscal_recompra,
          doc_fiscal_avariada: response.data.doc_fiscal_avariada,
          nota_normal: !response.data.doc_fiscal_recompra && !response.data.doc_fiscal_avariada
        });

        if (!response.data.doc_fiscal_recompra) {
          this.qtd_volumes_total += response.data.qtde_total;
        }
        this.qtd_volumes_bipados_total += response.data.qtde_bipada;

        this.qtde_nfs = this.notas_fiscais.length;
        if (!response.data.doc_fiscal_recompra) {
          this.peso_bruto_total =
              this.peso_bruto_total + response.data.peso_bruto_nf;
        }

        this.$snotify.success(
            "Nota fiscal N : " + response.data.num_fiscal + " bipada",
            "Sucesso"
        );
      }
    },
    checaDisabledBotao() {
      let isRepurchase = false;
      let ifExistsRepurchase = false;
      let typeInvoiced = [];
      let volumeNotBiped = false;
      this.notas_fiscais.forEach((item, i) => {
        if (item.status.valor == 1) {
          this.isDisabled = true;
        }
        if((item.qtde_total == item.qtde_bipada) && item.qtde_bipada == 0){
          this.isDisabled = true;
        }
        let notaNormal = false;
        if (item.doc_fiscal_avariada) typeInvoiced.push('avaria');
        else if (item.doc_fiscal_recompra) typeInvoiced.push('recompra');
        else {
          typeInvoiced.push('normal');
          notaNormal = true;
        }
        if (item.doc_fiscal_recompra && (item.qtde_total == item.qtde_bipada)) {
          isRepurchase = true;
        }
       
        if (!volumeNotBiped && notaNormal && !item.doc_fiscal_recompra && !item.doc_fiscal_avariada){
          if (item.qtde_total != item.qtde_bipada) {
            volumeNotBiped = true;
          } else {
            volumeNotBiped = false;
          }
        }
        if (item.doc_fiscal_recompra || item.doc_fiscal_avariada) {
          ifExistsRepurchase = true;
        }
      });

      if (ifExistsRepurchase) {
        if (volumeNotBiped) {
          this.isDisabled = true;
        } else if (isRepurchase) {        
            this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      } else {
        if (volumeNotBiped) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }

    },
    handleFechar() {
      this.$parent.onFilterReset();
      this.showModal = false;
      if (this.tp_fechar == true && this.notas_fiscais.length > 0) {
        this.$snotify.success(
          "Carga " + this.notas_fiscais[0].num_carga + " iniciada com sucesso.",
          "Sucesso"
        );
      }
    },
    onValidate(e, isCargaEspecial) {
      e.preventDefault();
      this.loading = true;
      this.notas_fiscais.forEach((obj) => {
        this.docfis.push(obj.docfis_id);
      });
      this.form.docfis = this.docfis;
      this.form.is_carga_especial = isCargaEspecial;
      this.form
        .post("/api/montagemcarga/bip/valida")
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.onFilterReset();
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });      
    },
    onStore(isCargaEspecial) {
      this.loading = true;
      this.isDisabled = true;
      this.notas_fiscais.forEach((obj) => {
        this.docfis.push(obj.docfis_id);
      });
      this.form.docfis = this.docfis;
      this.form.is_carga_especial = isCargaEspecial;
      this.form
        .post("/api/montagemcarga/bip/store")
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.onFilterReset();
        })
        .catch((errors) => {
          if(errors.tp_message == "warning"){
            new ReturnApi(errors, this, true, null, null, false);
            this.$parent.onFilterReset();
          } else {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          }
          
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/montagemcarga/transportadora/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.onFilterReset();
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onRemoveNf(data, notas) {
      var docfiscais = [];
      var num_fiscal = data.doc_num_fiscal;
      var numeros_fiscais = "";

      notas.forEach((item, i) => {
        //Caso encontre uma nota q pertence ao mesmo cte
        if (
          data.doc_id != null &&
          item.doc_id != null &&
          data.doc_id == item.doc_id &&
          data.doc_id != item.doc_id
        ) {
          docfiscais.push(item.docfis_id);
          numeros_fiscais = item.num_fiscal + ", " + numeros_fiscais;
        }
      });
      var vm = this;
      // var multiplas = false;
      // var qtd_volumes_total = vm.qtd_volumes_total;
      // var qtd_volumes_bipados_total = vm.qtd_volumes_bipados_total;
      //Multiplas notas
      if (docfiscais.length > 2) {
        // multiplas = true;
        var text =
          "Esta nota pertence ao CTe " +
          num_fiscal +
          " que possui as notas " +
          numeros_fiscais +
          "todas serão excluídas dessa carga, deseja confirmar?";
      } else {
        // multiplas = false;
        //nota unica
        var text = "Deseja remover a nota " + data.num_fiscal + " da carga?";

        docfiscais.push(data.docfis_id);
        // vm.qtd_volumes_total -= data.qtde_total;
        // vm.qtd_volumes_bipados_total -= data.qtde_bipada;
      }

      let helpForm = this.helpForm;
      var carga_id = data.carga_id;
      var notas = docfiscais;
      const onConfirmUnitWrapper = () => {
        confirmDesassociarFn(vm, notas, carga_id);
      };

      let confirmDesassociarFn = function (vm, notas, carga_id) {
        vm.loading = true;
        vm.helpForm.docfiscais = docfiscais;
        vm.helpForm.carga_id = carga_id;
        vm.helpForm
          .patch("/api/montagemcarga/bip/remover")
          .then((response) => {
            vm.onCreateNew(null, 2, vm.helpForm.carga_id);
            if (vm.notas_fiscais.length == 0 || vm.form.carga_id == "") {
              vm.observacao = "";
            }
            new ReturnApi(response, vm, true, null, null, false);
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };

      let obj = {
        title: "Atenção!",
        message: text,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    onRowClass(data, index) {
      return data.status.valor == 1
          ? (data.doc_fiscal_avariada || data.doc_fiscal_recompra ? 'table-info' : 'table-warning')
          : 'table-success';
    },
    listaRedespacho(search) {
      if (search.length >= 3) {
        this.isLoadingRedespacho = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
            .post("/api/pessoa/jsonlist/fornecedor")
            .then((response) => {
              this.optionsRedespacho = [];
              new ReturnApi(response, this, true, false, false);
              if (response.items.length > 0) {
                response.items.forEach((obj) => {
                  if (obj.pessoa.status != 2) {
                    this.optionsRedespacho.push({
                      label:
                          "PJ -" +
                          obj.pessoa.cd +
                          " - " +
                          obj.nome_fantasia +
                          " - " +
                          obj.razao_social +
                          " - " +
                          this.onFormataCnpj(
                              obj.cnpj_base,
                              obj.cnpj_filial,
                              obj.cnpj_digito
                          ) +
                          " - " +
                          obj.inscricao_estadual,
                      pessoa_id: obj.pessoa_id,
                      value: obj.pessoa_id,
                    });
                  }
                });
              }
              if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                  this.optionsRedespacho.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                  this.optionsRedespacho.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              this.isLoadingRedespacho = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
            })
            .finally(() => {
              this.checaDisabledBotao();
            });
      }
    },
    handleKeyDown(event) {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "c" || event.key === "v")
      ) {
        event.preventDefault();
      }
    },
    handleContextMenu(event) {
      event.preventDefault();
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    checkPermissionBip() {
      return this.getPermissionFw("montagemcarga.digitaretiqueta");
    },
    qtdCaracteres() {
      return this.cd_barra.length;
    },
    onUpdateObs() {
      this.form.observacao = this.observacao;
      this.form.patch("/api/montagemcarga/obs/update/" + this.form.carga_id);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>
<style>
.horizontal-scroll {
  overflow-y: auto;
}
</style>